export const basicFoodsKey = 'basicFoods'
export const fetchBasicFoodsKey = 'fetched-basic-foods'
export const loginKey = 'logged-in'
export const tokenKey = 'token'
export const lastedOpened = 'lasted-opened'
export const profileKey = 'profile'
export const versionKey = 'version'
